import React from "react";
import Paper from "@material-ui/core/Paper";
import Body from "@components/typography/Body";

import { ThemeType } from "@theme";
import locale from "@bonliva-crm/locale";
import { makeStyles } from "@material-ui/core/styles";

type Props = {
  limit: number;
  total: number;
};

export function TrunqWarning(props: Props) {
  const classes = useStyles({});
  return (
    <Paper className={classes.root}>
      <Body color="error">{locale.TruncatedRecordSet(props.limit, props.total)}</Body>
    </Paper>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    padding: theme.spacing()
  }
}));
